import { useCallback } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';
import { useOpenHouseholdChatConversation } from '@/modules/household/chat/hooks/useOpenHouseholdChatConversation';
import { useTrowser } from '@/modules/navigation/trowsers/trowser.context';
import { TrowserKey } from '@/modules/navigation/trowsers/trowser.types';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

import { getValidationQuestionsPath } from '../validationQuestions.paths';

/** Open the enhanced form on its overview host, or the persisted chat when the flag is off. */
export function useOpenValidationQuestions() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { open } = useTrowser(TrowserKey.ValidationQuestions);
  const enhanced = useFeatureFlag('enhanced_household_onboarding_flow');
  const openChat = useOpenHouseholdChatConversation();

  return useCallback(
    (householdId: string, conversationId: string) => {
      if (!enhanced) {
        openChat(householdId, conversationId);
        return;
      }
      const path = getCompletePathFromRouteKey(
        ROUTE_KEYS.HOUSEHOLD_DETAILS_OVERVIEW,
        { householdId }
      );
      if (matchPath({ path, end: true }, pathname)) {
        open({ target: householdId });
        return;
      }
      navigate(getValidationQuestionsPath(householdId));
    },
    [enhanced, navigate, open, openChat, pathname]
  );
}
